import { keepPreviousData, useQuery } from "@tanstack/react-query";
import axiosInstance from "../../axiosConfig";
import {
  SubiektTasksResponse,
  SubiektTaskStatus,
} from "../../types/SubiektTaskTypes";

// Connector asks for tasks every 30 seconds, so the list changes on its own
const REFETCH_INTERVAL = 10000;

export default function useGetTasks(
  page: number,
  status: SubiektTaskStatus | null
) {
  return useQuery({
    queryKey: ["subiektTasks", page, status],
    queryFn: async () => {
      return axiosInstance
        .get(`/subiekt/tasks?page=${page}${status ? `&status=${status}` : ""}`)
        .then((res) => res.data);
    },
    placeholderData: keepPreviousData,
    select: (data: SubiektTasksResponse) => data,
    refetchInterval: REFETCH_INTERVAL,
    retry: false,
  });
}
